import { render, staticRenderFns } from "./TagSimple.vue?vue&type=template&id=478469d9&"
import script from "./TagSimple.vue?vue&type=script&lang=js&"
export * from "./TagSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports